// @core/api/endpoints/billing/get_account_balance.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetAccountBalanceResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get account balance
 * Returns the current or historical balance for a specific account. Can specify an as-of date to retrieve the balance at a point in time.
 */
export async function GetAccountBalance(
  id: string,
  options?: RequestOptions
): Promise<GetAccountBalanceResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/accounts/:id/balance`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetAccountBalanceResponse>(requestPath, { ...requestOptions });
}
